const AVATAR_BASE_URL = "https://static-assets.amberstudent.com/images/Avatars";

const AVATARS = [
  `${AVATAR_BASE_URL}/avatar-1.png`,
  `${AVATAR_BASE_URL}/avatar-2.png`,
  `${AVATAR_BASE_URL}/avatar-3.png`,
  `${AVATAR_BASE_URL}/avatar-4.png`,
  `${AVATAR_BASE_URL}/avatar-5.png`,
  `${AVATAR_BASE_URL}/avatar-6.png`,
];

/**
 * Returns a deterministic avatar based on the reviewer's name or index.
 * Uses a simple hash of the name to pick consistently (same name = same avatar).
 * Falls back to index-based cycling if name is empty.
 */
// eslint-disable-next-line import/prefer-default-export
export function getRandomAvatar(name: string, index: number): string {
  if (name) {
    // Simple hash from name characters
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) {
      hash = (hash * 31 + name.charCodeAt(i)) % AVATARS.length;
    }
    return AVATARS[Math.abs(hash) % AVATARS.length];
  }
  return AVATARS[index % AVATARS.length];
}
